export interface TTickerItem {
  text: string | null
  icon: EIconType
  footNoteText: string | null
  footNoteIndicator: string | null
}

export const enum EIconType {
  NO_ICON = 'No Icon',
  CUSTOMER_SERVICE = 'Customer Service',
  TOP_DEAL = 'Top Deal',
  EXCHANGE = 'Exchange',
  EXCHANGE_30 = 'Exchange 30 Days',
  MEDAL = 'Medal',
  SHIELD = 'Shield',
}
